import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BudgetFiscalPeriodContainerModel } from "../../../../../../models/aggregates/erp/financial/";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({
  providedIn: "root",
})
export class BudgetFiscalPeriodService extends BaseApiTemplateService<BudgetFiscalPeriodContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget-fiscal-periods/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget-fiscal-periods/backoffice-ep";
    this.httpClient = http;
  }
}
